module.exports = __webpack_public_path__ + "assets/img/consumptionQuantity.b79a694f.png";